import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { WorkflowService } from '../services/workflow.service';

export const skipStepGuard: CanActivateFn = (route) => {
  const workflowService = inject(WorkflowService);
  if(workflowService.skippableSteps$().has(route.url[0].path)) {
    workflowService.skipStep();
  }
  return true;
};
